import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumbs } from "../../components/core/Breadcrumbs";
import { UpsertSafekeepingMappingForm } from "../../features/parameters/safekeeping-mapping/UpsertSafekeepingMappingForm";

import { AuthenticatedLayout } from "../../features/user/layouts/AuthendicatedLayout";

export const EditSafekeepingMapping = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, [id, navigate]);

  return (
    <AuthenticatedLayout>
      <Breadcrumbs />
      <UpsertSafekeepingMappingForm id={id} />
    </AuthenticatedLayout>
  );
};
